import {
  SIGNALR_EVENTS,
  type NotifyStandardExportProgressData,
} from '~/constants/signalREvents'
import { useSignalREvents } from './useSignalR'
import { useProjectReportsStore } from '~/stores/projectReports'
import { useAAPExportReportsStore } from '~/stores/AAPExportReports'
import { notifyFailure } from '~/utils/notifications'
import type { EnumerationsExportStatus } from 'client'

export const useProjectExport = () => {
  const signalR = useSignalREvents()
  const ProjectReportsStore = useProjectReportsStore()
  const AAPExportReportsStore = useAAPExportReportsStore()

  const handleSRAExportProgress: (
    ...args: NotifyStandardExportProgressData
  ) => void = (
    reportNotificationID: string,
    downloadID: string,
    percentage: number,
    status: number,
    stepDescription: string
  ) => {
    if (
      AAPExportReportsStore.reportBeingExported?.notificationID ===
      reportNotificationID
    ) {
      AAPExportReportsStore.reportBeingExported = {
        ...AAPExportReportsStore.reportBeingExported,
        notificationID: reportNotificationID,
        exportStatus: status as EnumerationsExportStatus,
        percent: percentage,
        currentStepDescription: stepDescription,
      }
    }
  }

  const handleSRAExportCompleted = async (reportNotificationID: string) => {
    if (
      AAPExportReportsStore.reportBeingExported?.notificationID ===
      reportNotificationID
    ) {
      AAPExportReportsStore.reportBeingExported = {
        ...AAPExportReportsStore.reportBeingExported,
        percent: 1,
      }
      AAPExportReportsStore.loading = false
      ProjectReportsStore.loading.export = false

      await ProjectReportsStore.downloadReport(
        AAPExportReportsStore.reportBeingExported.notificationID
      )

      setTimeout(() => {
        AAPExportReportsStore.isDownloading = false
        AAPExportReportsStore.clearExportData()
      }, 600)
    }
  }

  const handleSRAExportFailed = (reportNotificationID: string) => {
    if (
      reportNotificationID ===
      AAPExportReportsStore.reportBeingExported?.notificationID
    ) {
      AAPExportReportsStore.reportBeingExported.failed = true
      AAPExportReportsStore.loading = false
      ProjectReportsStore.loading.export = false

      notifyFailure('Export failed.  Please try again')
    }
  }

  const handleOn = () => {
    signalR.on(
      SIGNALR_EVENTS.EXPORT_HUB.NOTIFY_STANDARD_EXPORT_PROGRESS,
      handleSRAExportProgress
    )
    signalR.on(
      SIGNALR_EVENTS.EXPORT_HUB.NOTIFY_STANDARD_EXPORT_COMPLETED,
      handleSRAExportCompleted
    )
    signalR.on(
      SIGNALR_EVENTS.EXPORT_HUB.NOTIFY_STANDARD_EXPORT_FAILED,
      handleSRAExportFailed
    )
  }

  const handleOff = () => {
    signalR.off(
      SIGNALR_EVENTS.EXPORT_HUB.NOTIFY_STANDARD_EXPORT_PROGRESS,
      handleSRAExportProgress
    )
    signalR.off(
      SIGNALR_EVENTS.EXPORT_HUB.NOTIFY_STANDARD_EXPORT_COMPLETED,
      handleSRAExportCompleted
    )
    signalR.off(
      SIGNALR_EVENTS.EXPORT_HUB.NOTIFY_STANDARD_EXPORT_FAILED,
      handleSRAExportFailed
    )
  }

  onMounted(() => {
    handleOn()
  })

  onBeforeUnmount(() => {
    handleOff()
  })

  return {
    handleOn,
    handleOff,
  }
}
